module.exports = __webpack_public_path__ + "img/Panama.810983fa.svg";